module.exports = __webpack_public_path__ + "static/lframe-loans-11392f59e39f4a8d776551298ee055a6.png";